import { ServiceType } from "../ServiceType.data";
import ApiService from "../ApiService";
import ApiServiceBase from "../ApiServiceBase";
import { DocumentDetails, KYCDocumentsList } from "./KYCDocumentsService.type";
import { QueryPath } from "../QueryPath.data";
import { ResponseWithStatus } from "../../services/eligibilityService/EligibilityService.type";

class KYCDocumentService {
  public uploadKYCDocumentPath: QueryPath = { route: ["upload-kyc-document"] };
  public deleteKYCDocumentPath: QueryPath = { route: ["delete-kyc-document"] };

  public getKYCDocumentsList(): KYCDocumentsList | Promise<KYCDocumentsList> {
    const service: ApiServiceBase = new ApiService(ServiceType.Eligibility);

    return service.get({
      route: ["kyc-documents-list"]
    });
  }

  public getKYCUploadedDocumentList(
    eligibilityId: string
  ): DocumentDetails[] | Promise<DocumentDetails[]> {
    const service: ApiServiceBase = new ApiService(ServiceType.KYC);
    // passing eligibility id since it is autogenerated
    return service.get({
      query: { eligibilityId }
    });
  }

  public submitKYC(): ResponseWithStatus | Promise<ResponseWithStatus> {
    const service: ApiServiceBase = new ApiService(ServiceType.Eligibility);

    return service.post(
      {
        route: ["submit-kyc"]
      },
      {}
    );
  }

  public generatePDF(documentType: string): BlobPart | Promise<BlobPart> {
    const service: ApiServiceBase = new ApiService(ServiceType.Document);

    return service.get(
      {
        route: ["generate"],
        query: {
          documentType
        }
      },
      true
    );
  }
}

const KYCDocumentsService = new KYCDocumentService();

export default KYCDocumentsService;
